import React, { createContext, useState, useEffect, useContext } from 'react';
import { getConfig } from '../config';

const LoginSettingsContext = createContext();

export const LoginSettingsProvider = ({ children }) => {
	const [loginSettings, setLoginSettings] = useState({});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const item = { action: 'get_login_settings' };
				const web_link = getConfig().REACT_APP_WEB_LINK;
				const response = await fetch(web_link, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify(item),
				});
				const data = await response.json();
				if (data.type === 'Success' || data.type === 'success') {
					setLoginSettings(data.data);
				}
			} catch (err) {
				console.error('Failed to fetch login settings:', err);
			} finally {
				setLoading(false);
			}
		};

		fetchSettings();
	}, []);

	return (
		<LoginSettingsContext.Provider value={{ loginSettings, loading }}>
			{children}
		</LoginSettingsContext.Provider>
	);
};

export const useLoginSettings = () => useContext(LoginSettingsContext);
